import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './AccordionTrigger.scss';
import { offersCategory } from '../offers-category';
import { formatTestId } from '../../../utils/test-id/format-testid';

interface AccordionTriggerProps {
  name: string;
  isActive?: boolean;
  onClick?: () => void;
  hasChildren?: boolean;
  url?: string;
}

export const AccordionTrigger: FC<AccordionTriggerProps> = ({
  name,
  isActive = false,
  onClick,
  hasChildren = false,
  url,
}) => {
  const isOffer = offersCategory(name, 1);

  if (!hasChildren && url) {
    return (
      <a
        href={url}
        className={styles.accordionTrigger}
        data-testid={formatTestId(name, 'nav-')}
      >
        <span>{name}</span>
      </a>
    );
  }

  return (
    <button
      type="button"
      className={classNames(styles.accordionTrigger, {
        [styles.accordionTrigger__active]: isActive,
        [styles.accordionTrigger__chevronDown]: !isActive,
        [styles.accordionTrigger__chevronUp]: isActive,
        [styles.accordionTrigger__offer]: isOffer,
      })}
      onClick={onClick}
      aria-expanded={isActive}
      data-testid={formatTestId(name, 'nav-')}
    >
      <span>{name}</span>
    </button>
  );
};
